<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M1,4C1,4,15,4,15,4C15.55,4,16,3.55,16,3C16,2.45,15.55,2,15,2C15,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3.55,0.45,4,1,4C1,4,1,4,1,4ZM15,12C15,12,1,12,1,12C0.45,12,0,12.45,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12ZM15,7C15,7,1,7,1,7C0.45,7,0,7.45,0,8C0,8.55,0.45,9,1,9C1,9,15,9,15,9C15.55,9,16,8.55,16,8C16,7.45,15.55,7,15,7C15,7,15,7,15,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Menu',
} as DefineComponent
</script>
